module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/zh-hant_tohoku-c77a32eb8501bd7e9bf221c9d3fc5f6a.jpg";